import request from '../request';
import {RequestPageData, RequestReturnPromise, ResponsePageData} from './type';

export type GetChatListParams = RequestPageData<{}>;
export type GetChatListData = {
  /* */
  conversationId: string;

  /* */
  chatTime: string;

  app: string;
};

export function getChatList(
  params: GetChatListParams,
): RequestReturnPromise<ResponsePageData<GetChatListData>> {
  return request({
    url: '/api-internet-user/mp/ai/user/chat/record/page',
    params,
  });
}
